// extracted by mini-css-extract-plugin
export default {"sidebar_wrapper":"sidebar_sidebar_wrapper__9t6uZ","active_class":"sidebar_active_class__seQAf"};